import styled from 'styled-components';

export const ModalAtendimentos = styled.div`
  text-align: center;
  height: auto;
  display: flex;
  background: #f6f6f6;
  border-radius: 12px;
  width: 100%;

  
.button-prox {     
    background: #005a9e;
    color: #fff;
    height: 40px;
    width: 100px;
}

 .checkbox-wrapper-34 {
    --blue: #005a9e;;
    --g08: #E1E5EB;
    --g04: #848ea1;
    display: flex;
    margin-bottom: 10px;
   
  }
`;

export const ContainerTableAtendimentos = styled.div`
    width: 100%;
    padding: 20px;
    height: auto;
`;

export const ContainerTableAt = styled.div`
  width: 100%;
  margin: 0 auto;


    /* Custom scrollbar X styles */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 12px;
  }

  &::-webkit-scrollbar-thumb {
    background: #d4d4d4;
    border-radius: 12px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #b0b0b0;
  }
`;

export const ContainerControllers = styled.div`
  display: flex;
  width: 100%;

    .span {
      padding: 10px 100px;
      border-radius: 8px;
      font-size: 22px;
      color: #605d5d;
      background: #ffffff;
      box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px;
    }
  }
`;


export const ItemBtnExport = styled.div`
margin-top: 20px;
width:100%;
text-align:right;
`;

export const ContainerBusca = styled.div`
margin: 80px;
    display: inline-flex;
    align-items: center;

.input-id {     
    height: 40px;
    width: 400px;
}`;